module.exports = __webpack_public_path__ + "static/media/appstore-api-step-2.0211c415.png";